// Títulos y descripciones de cada página, para Google y para la pestaña del navegador.
// Los usa cada página al abrirse y el script scripts/prerender.js al publicar.
export const SITE_URL = 'https://uiquilmes.org';

export const PAGES = {
  home: {
    path: '/',
    title: 'Unión Industrial Quilmes (UIQ) | Cámara industrial',
    description:
      'Sumá tu empresa a la Unión Industrial Quilmes. Asesoramiento técnico, capacitaciones y networking para más de 180 empresas industriales de Quilmes y zona sur.',
  },
  socios: {
    path: '/socios',
    title: 'Padrón de socios | Unión Industrial Quilmes',
    description:
      'Directorio de las empresas industriales socias de la Unión Industrial Quilmes: rubro, dirección, web y redes de cada empresa.',
  },
  comision: {
    path: '/comision-directiva',
    title: 'Comisión Directiva | Unión Industrial Quilmes',
    description:
      'Autoridades de la Unión Industrial Quilmes: presidente, mesa directiva, vocales y revisores de cuentas.',
  },
};
